import { Injectable } from '@angular/core';
import { BaseAPIService } from '../base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExamearquivoService extends BaseAPIService {

  constructor(protected http:HttpClient) { 
    super('exame/examearquivo/');
  }

  download(IdArquivo){
    return this.send<any>('download',  {IdArquivo:IdArquivo});
  }

  deletarArquivo(IdArquivo){
    return this.send<any>('deletarArquivo',  {IdArquivo:IdArquivo});
  }
}
